enum RoutePaths {
  Root = '/',
  Login = '/login',
  CompleteAccount = '/complete-account',
  WelcomeAboard = '/welcome-aboard',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  Terms = '/terms',
  Privacy = '/privacy',
  Home = '/dashboard',
  Client = '/clients',
  HuddleClient = '/clients/huddle',
  Team = '/team',
  Tasks = '/tasks',
  Deals = '/deals',
  Salesforce = '/salesforce',
  Asana = '/asana',
  Businesses = '/businesses',
  ZoomInfo = '/zoominfo',
  Leads = '/leads',
  Contacts = '/contacts',
  Reports = '/reports',
}

export default RoutePaths;
